<template>
    <div :class="{ header: true, fixs: isFixeds }">
        <div class="flexible font-MT " :class="{ center: true, clearfix: true, bigheader: isbig }">
            <div class="logo">
                <img @click="goHome()" src="@/assets/logo.png" alt="logo" />
            </div>
            <ul class="nav-left flex">
                <li v-for="(item, index) in nav_left" :key="item.name" v-if="item.isShow">
                    <router-link  :to="item.url"
                        :class="(item.url == '/author' && $route.path.includes(item.url)) ? 'activeColor':''">
                        {{ item.name }}
                        <span v-if="item.url == '/author' && $route.path.includes(item.url)" class="line-auth"></span>
                        <span class="line"></span>
                    </router-link>
                </li>
            </ul>
            <ul class="nav-right flexible aItem-center">
                <li class="loginsmall">
                    <!-- v-if="token != null" -->
                    <el-popover v-if="token != null" placement="bottom" title="" width="120" popper-class="logoutCon"
                        trigger="hover">
                        <ul class="login-pop">
                            <li @click="toAddChild" v-if="(childList.length < 2)">
                                <img src="@/assets/login/ic_tjzh@2x.png" />
                                <span>添加子账号</span>
                            </li>
                            <li @click="toChangeAccount" v-if="(childList.length != 0)">
                                <img src="@/assets/login/ic_qhjh@2x.png" />
                                <span>切换账号</span>
                            </li>
                            <li @click="logout">
                                <img src="@/assets/login/ic_tc@2x.png" />
                                <span>安全退出</span>
                            </li>
                        </ul>
                        <div slot="reference" class="myheaderimg f18 font-MT f-tac f-csp">
                            <img :src="icon" />
                            <span class="f18 text-333 pl10">{{ name }}</span>
                            <i class="el-icon-caret-bottom f14 text-000"></i>
                        </div>
                    </el-popover>

                    <div v-else class="nologin f-tac f18 font-MT" @click="gologin()">
                        <a href="javaScript:">登录</a>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 添加账号弹框 -->
        <el-dialog :close-on-click-modal="false" :show-close="false" custom-class="childDia"
            :visible.sync="childDialog">
            <div class="child-wrap">
                <p class="f18 text-333 fwb-600">添加子账号</p>
                <el-input v-model="childName" placeholder="请输入子账号昵称"></el-input>
                <div class="logion-error" v-if="showError">
                    {{ errorText }}
                </div>
                <el-button class="f18 fwb-600 sub-btn" @click="toAddSure">确定</el-button>
            </div>
            <div class="dialog-close" v-if="childDialog || changeDialog" @click="closeChild()">
                <img src="../../assets/login/ic_close.png" />
            </div>
        </el-dialog>
        <!-- 切换账号弹框 -->
        <el-dialog :close-on-click-modal="false" :show-close="false" custom-class="changedDia"
            :visible.sync="changeDialog">
            <div class="change-wrap">
                <p class="f18 text-333 fwb-600">切换账号</p>
                <div class="info-wrap ">
                    <div class="info-wrap-item flexible" :class="activeAccount == index?'active':''"
                        v-for="(item,index) in childList" @click="clickInfo(item,index)">
                        <img :src="item.iconUrlSmall" />
                        <div class="f16 text-333 ">
                            {{ item.name }}
                            <img v-if="activeAccount == index" src="../../assets/login/ic_change.png" />
                        </div>
                    </div>
                </div>
                <el-button class="f18 fwb-600 sub-btn" @click="changeSure">确定</el-button>
            </div>
            <div class="dialog-close" v-if="childDialog || changeDialog" @click="closeChange()">
                <img src="../../assets/login/ic_close.png" />
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {
        getToken
    } from "utils/storage";
    import {
        mapGetters
    } from 'vuex';
    import {
        // getInfo
        accountListApi,
        addAccountApi,
        changeAccountApi
    } from "@/api/login";
    export default {
        props: {
            isbig: {
                type: Boolean,
                default: false
            },
            isAuthor: Boolean,
            isToken: String
        },
        data() {
            return {
                nav_left: [{
                        name: "首页",
                        url: "/",
                        isShow:true
                    },
                    {
                        name: "作家中心",
                        url: "/author",
                        isShow: getToken(),
                    },
                    {
                        name: "福利",
                        url: "/welfare",
                        isShow:true
                    },
                    {
                        name: "小程序",
                        url: "/download",
                        isShow:true
                    }
                ],
                // currentRouter: {},
                // qqurl: "",
                // weixinLogin: "",
                isFixeds: false,
                // isshowInfo: true,
                // isShowRight: false,
                token: getToken() || null,
                childDialog: false,
                childName: "",
                childList: [],
                changeDialog: false,
                activeAccount: 0,
                activeInfo: "",
                /* error信息 */
                showError: false,
                errorText: ""
            };
        },

        // computed: mapState({
        //     imgurl: state => state.user.img
        // }),
        computed: {

            ...mapGetters([
                'id',
                'name',
                'icon'
            ]),
        },
        created() {
            // console.log(getToken())
            if(getToken()) this.getAccountList()
          
        },
        methods: {
            toAddChild() {
                this.childName = "";
                this.childDialog = true;
            },
            toAddSure() {
                if (!this.childName) {
                    this.showError = true;
                    this.errorText = '请输入正确的昵称';
                    setTimeout(() => {
                        this.showError = false;
                    }, 3000);
                    return true
                }
                let params = {
                    userName: this.childName
                }
                addAccountApi(params).then(res => {
                    if (res.success) {
                        this.childDialog = false;
                        this.$success('custom', '绑定成功')
                        this.getAccountList()
                        // this.$router.replace('/')
                    }
                });
            },
            closeChild() {
                this.childDialog = false;
            },
            getAccountList() {
                accountListApi().then(res => {
                    if (res.success) {
                        if (res.data && res.data.length > 0) {
                            this.childList = res.data;
                            this.activeAccount = 0;
                            this.activeInfo = res.data[0];
                        }

                    }
                });
            },
            changeSure() {
                // console.log(this.activeInfo)
                let params = {
                    userId: this.activeInfo.id
                }
                changeAccountApi(params).then(res => {
                    if (res.success) {
                        this.changeDialog = false;
                        this.$store.dispatch('saveInfo', res.data)
                        this.$success('custom', '切换成功')
                        this.getAccountList()
                        this.$router.replace('/')
                        location.reload();

                    }
                });
            },
            toChangeAccount() {
                this.changeDialog = true;

            },
            closeChange() {
                this.changeDialog = false;
            },
            clickInfo(item, index) {
                this.activeAccount = index;
                this.activeInfo = item;
            },
            gologin() {
                this.$emit('changeLogin', true)
            },
            // goAuthor() {
            //     this.$router.push('/author')
            // },
            // goHome() {
            //     this.$router.push('/')
            // },
            /* 退出 */
            logout() {
                this.$store.dispatch('LogOut').then((res) => {
                    if (res.success) {
                        this.$success('custom', '成功退出！')
                        localStorage.clear();
                        this.$router.replace('/')
                        location.reload()
                        // this.token = getToken() || null
                    }
                })
            },
            // ==吸顶
            handleScroll() {
                var scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                if (scrollTop > 210) {
                    //提前判断要上升多少像素就固定
                    this.isFixeds = true;
                } else {
                    this.isFixeds = false;
                }
            },

        },
        mounted() {
            let _this = this;
            window.addEventListener("setItemEvent", function(e) {
                if (e.key === "rock-Token") {
                    _this.token = e.newValue;
                }
            })
        }
    };
</script>

<style lang="scss" scoped>
    .logoutCon {
        // width: 130px !important;
        box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1) !important;
        padding: 5px 0 !important;
        border-radius: 8px;
        margin-top: 20px !important;
        min-width: 160px;

        .logout-item {
            display: block;
            margin: 10px 20px;
        }

        .login-pop {
            li {
                padding: 10px 14px;
                cursor: pointer;

                img {
                    display: inline-block;
                    width: 18px;
                    height: 18px;
                    vertical-align: sub;
                }

                span {
                    color: #333;
                    font-size: 16px;
                    padding-left: 10px;
                }
            }

            li:hover {
                background: #F5F5F5;
            }
        }


    }

    .activeColor {
        color: #F68A01 !important;
    }

    .myheaderimg {
        line-height: 40px;
        margin-left: 20px;
        outline: none;

        img {
            display: inline-block;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            vertical-align: middle;
        }
    }

    .nologin {
        width: 120px;
        height: 44px;
        line-height: 44px;
        background: #F68A01;
        border-radius: 7px;
        cursor: pointer;

        a {
            color: #fff;
        }
    }

    .logion-error {
        width: 244px;
        height: 54px;
        background: rgba(0, 0, 0, 0.59);
        border-radius: 3px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 54px;
        text-align: center;
        position: absolute;
        top: 230px;
        left: 88px;

    }



    .line-auth {
        width: 100px;
        height: 4px;
        background: #F68A01;
        border-radius: 8px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
    }

    /deep/.router-link-exact-active {
        .line {
            width: 100px;
            height: 4px;
            background: #F68A01;
            border-radius: 8px;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
        }

    }

    .header {
        width: 100%;
        background: #fff;

        .center {
            width: 1400px;
            margin: 0 auto;
            height: 80px;
            line-height: 80px;
            font-size: 20px;
            color: #999;
            position: relative;

            &.bigheader {
                width: 1400px;
            }

        }

    }

    .logo {
        line-height: 80px;

        img {
            vertical-align: middle;
            width: 197px;
            height: 76px;
        }

    }

    .nav-left {
        margin-left: 210px;
        text-align: right;
        height: 80px;

        li {
            display: inline-block;
            position: relative;
            margin: 0 30px;

            .loginsmall {
                padding: 0;
            }

            a {
                font-size: 18px;
                display: inline-block;
                color: #333;

                &.router-link-exact-active {
                    color: #f68a01;
                }

                &:hover {
                    color: #f68a01;
                }

            }

        }

    }

    .nav-right {
        margin-left: 70px;
    }

    /deep/.el-dialog__wrapper {
        .childDia {
            width: 436px !important;
            height: 374px !important;
            background: #FFFFFF;
            box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
            border-radius: 34px !important;
            margin-top: 25vh !important;
        }

        .changedDia {
            width: 436px !important;
            height: 460px !important;
            margin-top: 20vh !important;
            background: #FFFFFF;
            box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
            border-radius: 34px !important;
        }

        .sub-btn {
            width: 100%;
            height: 46px;
            background: #F68A01;
            border-radius: 49px;
            text-align: center;
            color: #fff;

            border: none;
        }
    }

    /deep/.el-dialog__body {
        padding: 0;
    }

    /deep/.el-dialog__header {
        display: none;
        padding: 0;
    }

    .child-wrap {
        padding: 66px 48px 0;

        /deep/.el-input__inner {
            height: 52px;
            background: #F5F5F5;
            border-radius: 3px;
            border: none;
            color: #333;
            font-size: 16px;
            margin-top: 70px;
            margin-bottom: 83px;

            /deep/.el-form-item {
                margin-bottom: 30px;
            }

            &::placeholder {
                color: #999;
            }

        }


    }

    .change-wrap {
        padding: 66px 48px 0;

        .info-wrap {
            height: 280px;
            padding: 50px 0 30px;
            box-sizing: border-box;

            .info-wrap-item {
                margin-bottom: 50px;
                height: 52px;

                &>img {
                    display: inline-block;
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                }

                div {
                    width: 280px;
                    height: 50px;
                    line-height: 50px;
                    background: #F5F5F5;
                    border-radius: 6px;
                    border: 1px solid #F5F5F5;
                    position: relative;
                    margin-left: 12px;
                    padding-left: 30px;
                    margin-bottom: 50px;

                    img {
                        display: inline-block;
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        top: 16px;
                        right: 16px;
                        color: #F68A01;
                    }
                }
            }

            .active {
                div {
                    border: 1px solid #F68A01;
                }
            }
        }
    }

    .dialog-close {
        position: fixed;
        top: 85%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        width: 44px;
        height: 44px;

        img {
            width: 44px;
            height: 44px;
        }
    }
</style>